module.exports = __webpack_public_path__ + "img/logo_pravo_x2.37fd8bde.jpg";